var $ = require('jquery');
var _ = require('underscore');

module.exports.configure = function () {
    var preferences = EY.Consultation.CurrentUser.model && EY.Consultation.CurrentUser.model.get('preferences');
    var culture = preferences && preferences.culture
        ? _.last(preferences.culture.split('_'))
        : window.localStorage.getItem('consultation-user-culture') ? _.last(window.localStorage.getItem('consultation-user-culture').split('_')) : 'en-US';

    EY.Consultation.CurrentCulture = culture;
    return $.ajax({
        url: 'Consultation/Resources',
        data: {'culture': culture}
    }).done(function (data) {
        EY.Consultation.Labels = data;
        window.document.title = EY.Consultation.ApplicationName || data.ApplicationName;
    });
};


// WEBPACK FOOTER //
// ./js/Modules/Application/Labels.js